const styles = {
  spinner: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    color: 'primary',
    margin: '5rem auto',
  },
  toggleAddress: {
    box: {
      alignSelf: 'center',
    },
    button: {
      color: 'secondary.main',
      minWidth: '46px',
      '& > .MuiButton-startIcon': {
        margin: '0',
      },
      padding: '0.75rem 0.75rem',
    },
  },
  headerContent: {
    gap: 2,
    '& > .MuiCardHeader-content': {
      flex: 'none',
    },
  },
  titleStyle: {
    display: 'flex',
    flexWrap: 'wrap',
    lineHeight: 'normal',
    flexDirection: 'column',
    textAlign: 'left',
  },
  containerAreaMovements: (responsive) => ({
    flexDirection: 'row',
    display: 'flex',
    gap: '0.5rem',
    flexWrap: responsive ? 'wrap' : 'nowrap',
  }),
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '16px',
    paddingTop: '4px',
    paddingLeft: '24px',
  },
  adjustmentBox: { display: 'flex', gap: 2, mb: 1 },
  adjustmentLabel: { minWidth: 170 },
};

export default styles;
